import { inject } from 'vue'
import { patch } from '@rails/request.js'
import { useSaveStatus } from './useSaveStatus'
import { t } from '@/libs/i18n'

export function useSlideUpdate() {
  const updateSlides = inject('updateSlides')
  const { setStatus, setStatusToLastSaved, setIsSaving } = useSaveStatus()

  const updateSlide = async (updatePath, body, headers = { 'Content-Type': 'application/json' }, responseKind = 'json') => {
    const startTime = Date.now()
    setStatus(t('slides_editor.status_messages.saving'))
    setIsSaving(true)

    try {
      const response = await patch(updatePath, {
        body,
        headers,
        responseKind
      })

      if (response.ok) {
        await handleSuccessfulUpdate(response, startTime)
      } else {
        handleUpdateError(await response.json)
      }
    } catch (error) {
      handleUpdateError(error)
      throw error
    }
  }

  const handleSuccessfulUpdate = async (response, startTime) => {
    const parsedResponse = await response.json

    if (parsedResponse.slide) {
      updateSlides(parsedResponse.slide)
    }

    const elapsedTime = Date.now() - startTime
    const remainingTime = Math.max(0, 1000 - elapsedTime)
    setTimeout(setStatusToLastSaved, remainingTime)
    setIsSaving(false)
  }

  const handleUpdateError = (error) => {
    console.error('Error updating slide:', error)
    setStatus(t('slides_editor.status_messages.error_saving'))
    setIsSaving(false)
  }

  return { updateSlide }
}
